import {useEffect, useState} from 'react';

import {useStores} from '../stores/use-stores';

export default function useSelectedStore() {
  const {shopSelectionStore} = useStores();
  const [selectedStore, setSelectedStore] = useState(
    shopSelectionStore.selectedStore,
  );

  useEffect(() => {
    setSelectedStore(shopSelectionStore.selectedStore);
  }, [shopSelectionStore.selectedStore]);

  return selectedStore;
}

export const useIsSelectedStoreLoyaltyEnabled = () => {
  const {shopSelectionStore} = useStores();
  const [isSelectedStoreLoyaltyEnabled, setIsSelectedStoreLoyaltyEnabled] =
    useState(shopSelectionStore.loyaltyEnabled === true);

  useEffect(() => {
    setIsSelectedStoreLoyaltyEnabled(shopSelectionStore.loyaltyEnabled === true);
  }, [shopSelectionStore.loyaltyEnabled]);

  return isSelectedStoreLoyaltyEnabled;
};
